import * as betprofessor from './ActivityStatements.styles.betprofessor';
import * as betroyale from './ActivityStatements.styles.betroyale';
import * as fiestabet from './ActivityStatements.styles.fiestabet';
import * as goldenrush from './ActivityStatements.styles.goldenrush';
import * as juicybet from './ActivityStatements.styles.juicybet';
import * as puntcity from './ActivityStatements.styles.puntcity';
import * as sterlingparker from './ActivityStatements.styles.sterlingparker';
import * as vikingbet from './ActivityStatements.styles.vikingbet';
import * as volcanobet from './ActivityStatements.styles.volcanobet';
import * as wellbet from './ActivityStatements.styles.wellbet';
import * as junglebet from './ActivityStatements.styles.junglebet';
import * as oldgill from './ActivityStatements.styles.oldgill';
import * as sugarcastle from './ActivityStatements.styles.sugarcastle';
import * as buffalobet from './ActivityStatements.styles.buffalobet';
import * as titanbet from './ActivityStatements.styles.titanbet';
import * as slambet from './ActivityStatements.styles.slambet';
import * as gigabet from './ActivityStatements.styles.gigabet';
import * as betstride from './ActivityStatements.styles.betstride';
import * as chromabet from './ActivityStatements.styles.chromabet';
import * as templebet from './ActivityStatements.styles.templebet';
import * as bet777 from './ActivityStatements.styles.bet777';
import * as betblast from './ActivityStatements.styles.betblast';
import * as magnumbet from './ActivityStatements.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  chromabet,
  templebet,
  bet777,
  betblast,
  magnumbet,
};
